import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DokumentAnlegenAction from './DokumentAnlegenAction';
import Modal from '../../Modal/Modal';

export default ({ knoten, addNewDokumentToKnoten, alleTags }) => {
    const [modalOpen, toggleModal] = useState(false);

    return (
        <React.Fragment>
            <button
                className="inhaltselement-anlegen-btn btn btn-sm btn-primary d-flex align-items-center"
                title="Dokument anlegen"
                onClick={() => toggleModal(!modalOpen)}>
                <FontAwesomeIcon icon="plus" />
            </button>
            {modalOpen && (
                <Modal onClose={() => toggleModal(!modalOpen)} size="md" title={`Dokument erstellen in ${knoten.name} `} canClose={true}>
                    <DokumentAnlegenAction toggleModal={toggleModal} knoten={knoten} addNewDokumentToKnoten={addNewDokumentToKnoten} alleTags={alleTags} />
                </Modal>
            )}
        </React.Fragment>
    );
};
